import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialMediaAddDesignModalProps} from '@Modals/social-media-add-design-modal/social-media-add-design-modal.types';

export const openSocialMediaAddDesignModal = (props: SocialMediaAddDesignModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_MEDIA_ADD_DESIGN_MODAL,
      panelProps: props,
    })
  );
};
